<script>
  import Button from '../common/Button.svelte';
  import ButtonGroup from '../common/ButtonGroup.svelte';
  
  export let value; // 프로젝트 객체
  export const row = null; // 프로젝트 객체 (같은 값)
  export const column = null;
  export const index = null;
  
  // 이벤트 디스패처
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  
  function handleEdit() {
    // 부모의 부모로 이벤트 전파 (DataTable -> 부모 컴포넌트)
    const event = new CustomEvent('edit', { 
      detail: value,
      bubbles: true 
    });
    document.dispatchEvent(event);
  }
  
  function handleDelete() {
    // 부모의 부모로 이벤트 전파 (DataTable -> 부모 컴포넌트)
    const event = new CustomEvent('delete', { 
      detail: value,
      bubbles: true 
    });
    document.dispatchEvent(event);
  }
</script>

<div class="project-actions">
  <ButtonGroup size="sm" direction="horizontal">
    <Button 
      variant="primary" 
      size="sm"
      on:click={handleEdit}
    >
      수정
    </Button>
    <Button 
      variant="danger" 
      size="sm"
      on:click={handleDelete}
    >
      삭제
    </Button>
  </ButtonGroup>
</div>

<style>
  .project-actions {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style> 